import pyClient from '../PyAPI_Config'

async function startSpreadsheet(
  authState: any,
  study_id: string,
  phase_id: string,
  UAIs: number[],
) {
  return await pyClient(authState)
    .post<any>(`/study/${study_id}/spreadsheet?phase_id=${phase_id}`, UAIs)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function updateSpreadsheet(
  authState: any,
  study_id: number | string | undefined,
  data_collection_id: string,
  abandon = false,
) {
  return await pyClient(authState)
    .patch<any>(
      `/study/${study_id}/spreadsheet?data_collection_id=${data_collection_id}&abandon=${abandon}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function checkSpreadsheet(
  authState: any,
  study_id: number | string | undefined,
  data_collection_id: string,
) {
  return await pyClient(authState)
    .get<any>(
      `/study/${study_id}/spreadsheet?data_collection_id=${data_collection_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function hideSpreadsheetHistory(
  authState: any,
  study_id: number | string | undefined,
  data_collection_id: string,
) {
  return await pyClient(authState)
    .delete<any>(
      `/study/${study_id}/spreadsheet/history?data_collection_id=${data_collection_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function showSpreadsheetHistory(
  authState: any,
  study_id: number | string | undefined,
  data_collection_id: string,
) {
  return await pyClient(authState)
    .put<any>(
      `/study/${study_id}/spreadsheet/history?data_collection_id=${data_collection_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function hideSpreadsheetDetails(
  authState: any,
  study_id: number | string | undefined,
  data_collection_id: string,
) {
  return await pyClient(authState)
    .delete<any>(
      `/study/${study_id}/spreadsheet/animal_details?data_collection_id=${data_collection_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function showSpreadsheetDetails(
  authState: any,
  study_id: number | string | undefined,
  data_collection_id: string,
) {
  return await pyClient(authState)
    .put<any>(
      `/study/${study_id}/spreadsheet/animal_details?data_collection_id=${data_collection_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const SpreadsheetService = {
  startSpreadsheet,
  updateSpreadsheet,
  checkSpreadsheet,
  hideSpreadsheetHistory,
  showSpreadsheetHistory,
  hideSpreadsheetDetails,
  showSpreadsheetDetails,
}

export default SpreadsheetService
